import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewFno, UpdateFno, getAllFno } from "../../Services/fno-services";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import ButtonModal from "../Modals/buttonModal";
import { useNavigate } from "react-router-dom";
import { isNumber, isAlphanumericWithDotSpaceDashCommaBrackets } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import { sortBySeqNoInDescending } from "../../functions/welding-functions";

const AddEditFnoMaster = (props) => {
  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }

  let action = props.action;
  let formName = "F No.";

  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [toggleClass, setToggleClass] = useState(
    (action === "Edit" ? props.rowdata.wld_status : true) ? "activeToggleLabel" : "inactiveToggleLabel"
  );
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");

  const [FnoObj, setFnoObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_category: "",
        SK: "",
        PK: "Fno",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );
  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_category: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setFno",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFnoObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setFnoObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setFnoObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_category: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
      }));
      setToggleClass("activeToggleLabel");
    } else if (action === "Edit") {
      setFnoObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_category: props.rowdata.wld_category,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
      }));
      setToggleClass(props.rowdata.wld_status ? "activeToggleLabel" : "inactiveToggleLabel");
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_category: {},
      SK: {},
    }));
  };

  const validateFno = async (action) => {
    let result = false;
    let isError = false;

    if (FnoObj.wld_code.trim() === "") {
      FnoObj.wld_code = "";
      isError = true;
      error.wld_code = {
        status: true,
        message: "Fno Code is required.",
      };
    }
    if (FnoObj.wld_category.trim() === "") {
      FnoObj.wld_category = "";
      isError = true;
      error.wld_category = {
        status: true,
        message: "Fno Category is required.",
      };
    }

    if (FnoObj.wld_status === "") {
      isError = true;
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }
    const fnoData = await getAllFno();
    let maxSeqNo = 0;
    if (action === "Add") {
      if (fnoData?.length > 0) {
        let sortedArr = fnoData.filter(obj => obj.hasOwnProperty("SeqNo")).sort(sortBySeqNoInDescending("SeqNo"));
        maxSeqNo = sortedArr.length > 0 ? sortedArr[0].SeqNo : maxSeqNo;
        result = fnoData.find((item) =>
          item.wld_code.toLowerCase() === FnoObj.wld_code.toLowerCase() &&
          item.wld_category.toLowerCase() === FnoObj.wld_category.toLowerCase()
        );
      }
      FnoObj.SeqNo = parseInt(maxSeqNo) + 1;
    }
    else {
      result = fnoData.find((item) =>
        item.SK.toLowerCase() != FnoObj.SK.toLowerCase() &&
        item.wld_code.toLowerCase() === FnoObj.wld_code.toLowerCase() &&
        item.wld_category.toLowerCase() === FnoObj.wld_category.toLowerCase()
      );
    }
    if (result) {
      setAlertMessage("Combination of F No and F Category already exists!");
      isError = true;
    }
    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (error.wld_code.status || error.wld_category.status) {
      isError = true;
    }
    return isError;
  };

  const handleAdd = async (e) => {
    let result;
    if (FnoObj.wld_status === true) {
      FnoObj.wld_status = "Active";
    } else {
      FnoObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      FnoObj.SK = "Fno#" + FnoObj.wld_code + "#SeqNo#" + FnoObj.SeqNo;
      FnoObj.wld_createdby = username;
      result = await AddNewFno(FnoObj);
    } else {
      FnoObj.SeqNo = Number(FnoObj.SeqNo);
      FnoObj.wld_updatedby = FnoObj.wld_createdby;
      result = await UpdateFno(FnoObj);
    }
    if (result?.status) {
      showSuccess(result.message);
      props.setReload(!props.reload)
      setShowForm(false);
      props.onHide();
    }
    else {
      showWarning(result.message);
      setshowConfirmModel(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validateErr = await validateFno(action);
    if (!validateErr) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Fno successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} F No. </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        disabled={action === "Edit"}
                        maxLength="5"
                        className={
                          error.wld_code.status
                            ? " g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={FnoObj.wld_code}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        F No.
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_code.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px" }}>
                          {error.wld_code.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_category"
                        name="wld_category"
                        type="text"
                        maxLength="20"
                        className={`asterisk ${error.wld_category.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={FnoObj.wld_category}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_category: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_category">
                        F No. Category
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_category.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "10px" }}>
                          {error.wld_category.message}
                        </span>
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={FnoObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {FnoObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditFnoMaster;